import { Component } from "@angular/core";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { KpiCardComponent } from "../kpi-card/kpi-card.component";
import { NewUiKpiGridPanelComponent } from "./new-ui-kpi-grid-panel.component";

@Component({
  selector: "app-kpi-grid-panel",
  templateUrl: "./kpi-grid-panel.component.html",
  styleUrl: "./kpi-grid-panel.component.scss",
  imports: [TranslateDirective, KpiCardComponent],
})
export class KpiGridPanelComponent extends NewUiKpiGridPanelComponent {}
